import chairs from "../../assets/chairs.png";
import quraan from "../../assets/quraan.png";
import parking from "../../assets/parking.png";
import cofee from "../../assets/cofee.png";
import "./style.css";

const Categories = () => {
	let data = [
		{ title: "Valet Parking", img: parking },
		{ title: "Distributions", img: quraan },
		{ title: "Chairs", img: chairs },
		{ title: "Hospitality", img: cofee },
	];
	return (
		<div
			className="categories"
			id="categories"
			data-aos="fade-up"
			data-aos-duration="1200">
			<div className="container">
				<p className="title">Categories</p>
				<div className="row">
					{data?.map((res, index) => {
						return (
							<div key={index} className="col-md-3 col-6">
								<div className="category-card">
									<div className="category-card-image">
										<img src={res?.img} alt={res?.title} />
									</div>
									<p>{res?.title}</p>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		</div>
	);
};
export default Categories;
